import { put, all, call, takeLatest } from 'redux-saga/effects'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { interviewRequestsModule, companyModule, messagesModule } from '../modules'

import {
  fetchInterviewRequestDetail,
  fetchInterviewRequests,
  fetchInterviewRequestCounts,
  setInterviewRequestDeclineReason,
  setInterviewRequestStatus,
  setInterviewRequestCandidateStatus,
} from '../apiModules/interviewRequests'

import { fetchCompany } from '../apiModules/company'
import { fetchMessages } from '../apiModules/messages'

function* fetchInterviewRequestsSaga({ payload }) {
  yield put(interviewRequestsModule.fetchLoading(true))
  const response = yield fetchInterviewRequests(payload.id, payload.filter)
  yield put(interviewRequestsModule.fetchSuccess(response))
}

function* fetchInterviewRequestCountsSaga({ payload }) {
  const response = yield fetchInterviewRequestCounts(payload)
  yield put(interviewRequestsModule.fetchCountsSuccess(response))
}

function* fetchInterviewRequestDetailSaga({ payload }) {
  yield put(interviewRequestsModule.fetchLoading(true))

  const [interviewRequest, company, messages] = yield all([
    call(fetchInterviewRequestDetail, payload),
    call(fetchCompany, payload),
    call(fetchMessages, payload),
  ])

  yield all([put(companyModule.fetchSuccess(company)), put(messagesModule.fetchSuccess(messages))])

  yield put(interviewRequestsModule.fetchDetailSuccess(interviewRequest))
}

function* setInterviewRequestStatusSaga({ payload }) {
  yield put(interviewRequestsModule.updating(true))

  try {
    const response = yield setInterviewRequestStatus(payload.id, payload.data)
    yield put(interviewRequestsModule.setStatusSuccess(response))

    if (payload.data?.status === 'declined' && response.result?.decline_reason !== 'auto_declined_overdue') {
      yield put(interviewRequestsModule.toggleDeclineReasonsModal(true))
    }
    yield put(messagesModule.fetch(payload.id))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(interviewRequestsModule.setStatusFailure(error))
  }
}

function* setInterviewRequestCandidateStatusSaga({ payload }) {
  yield put(interviewRequestsModule.updatingCandidateStatus(true))

  try {
    const response = yield setInterviewRequestCandidateStatus(payload.id, payload.data)

    yield put(interviewRequestsModule.setCandidateStatusSuccess(response))

    analytics.track('interview-request-candidate-status', {
      interview_request_id: payload.id,
      status: payload.data.status,
      company_name: payload.data.company,
    })
  } catch (error) {}
}

function* setInterviewRequestDeclineReasonSaga({ payload }) {
  yield put(interviewRequestsModule.toggleSettingDeclineReason(true))

  try {
    yield setInterviewRequestDeclineReason(payload.id, payload.data)
    yield put(interviewRequestsModule.toggleSettingDeclineReason(false))
    yield put(interviewRequestsModule.toggleDeclineReasonsModal(false))
  } catch (err) {
    yield put(interviewRequestsModule.toggleSettingDeclineReason(false))
    yield put(interviewRequestsModule.toggleDeclineReasonsModal(false))
  }
}

export default function* watchInterviewRequestsSaga() {
  yield takeLatest(interviewRequestsModule.FETCH, fetchInterviewRequestsSaga)
  yield takeLatest(interviewRequestsModule.FETCH_COUNTS, fetchInterviewRequestCountsSaga)
  yield takeLatest(interviewRequestsModule.FETCH_DETAIL, fetchInterviewRequestDetailSaga)
  yield takeLatest(interviewRequestsModule.SET_STATUS, setInterviewRequestStatusSaga)
  yield takeLatest(interviewRequestsModule.SET_CANDIDATE_STATUS, setInterviewRequestCandidateStatusSaga)
  yield takeLatest(interviewRequestsModule.SET_DECLINE_REASON, setInterviewRequestDeclineReasonSaga)
}
